import $ from 'jquery'
import {
    prefix
} from './globals';
import {
    BaseForm,
    EMAIL_REG, MESSAGE_ONLY_LETTER,
    MESSAGE_REQUIRED, ONLY_LETTER_REG,
} from './form/BaseForm'

class SimpleForm extends BaseForm {
    constructor() {
        super();

        this.$form = $(`.${prefix}-simple-form`);

        if (this.$form.length === 0)
            return;

        this.init();
    }

    init() {
        this.sending = false;
        this.$fullNameInput = this.$form.find('#sfname');
        this.$emailInput = this.$form.find('#sfemail');
        this.$certifyCheckInput = this.$form.find('#checked-simple-form');
        this.$submitButton = this.$form.find("#submit-simple-form");

        this.$submitButton.on('click', this.onSubmitButton);
        this.initValidationFields()
        this.assignElementOnlyAllowLetter(this.$fullNameInput);
    }

    initValidationFields = () => {
        this.fieldsValidation = {
            fullname: {
                $field: this.$fullNameInput,
                type: 'text',
                rules: [
                    {
                        required: true,
                        message: MESSAGE_REQUIRED
                    },
                    {
                        regex: ONLY_LETTER_REG,
                        message: MESSAGE_ONLY_LETTER,
                    },
                ]
            },
            email: {
                $field: this.$emailInput,
                type: 'text',
                rules: [
                    {
                        required: true,
                        message: MESSAGE_REQUIRED
                    },
                    {
                        regex: EMAIL_REG,
                        message: 'Please enter a valid email address.',
                    },
                ]
            },
            age: {
                $field: this.$certifyCheckInput,
                type: 'checkbox',
                rules: [
                    {
                        checked: true,
                        message: 'This must be checked.'
                    },
                ]
            },
        };
    }

    onCheckBoxKeyPressed = () => {
        const $self = this;
        $("#checked-simple-form").keydown(function (event) {
            if (event.keyCode === 13) {
                this.checked = !this.checked;
                $self.validateForm();
            }
        });
    }


    onSubmitButton = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (this.validateForm()) {
            this.onSubmitForm();
        }

        return false;
    }

    onSubmitForm = () => {
        if (this.sending) return;
        this.sending = true;
        this.$submitButton.after(`<div class="${prefix}-loader secondary">Loading...</div>`);
        this.$submitButton.remove();

        const currentDate = new Date();
        const timestamp = currentDate.getTime();
        const data = {
            EMAIL: this.$emailInput.val(),
            FNAME: this.$fullNameInput.val(),
            LNAME: 'LNAME',
            'group[647][1]': 1,
            'b_c3ebcdb095cc3ea77bae0d533_d46f68e1d6': '',
            _: timestamp
        };

        $.ajax({
            type: "GET",
            url: this.$form.find('form').attr('action') + '&' + (new URLSearchParams(data).toString()),
            success: () => {
                this.$form.addClass('hide');
                this.$form.after(
                    '<div class="get-involved-message secondary"><h4>Thank you for subscribing!</h4></div>'
                );
                this.sending = false;
            },
            error: () => {
                this.$form.addClass('hide');
                this.$form.after(
                    '<div class="get-involved-message secondary"><h4>Thank you for subscribing!</h4></div>'
                );
                this.sending = false;
            },
            dataType: "text",
        });
    }
}

export default SimpleForm;
